import { all, call, put, takeEvery } from 'redux-saga/effects';
import { fetchUserTiers, listLoaded } from './index';
import { request } from '@wix/da-shared-react/pkg/xhr';

function* handleFetch() {
  const response = yield call(request, {
    method: 'get',
    url: '/tier/user/list',
  });

  yield put(listLoaded({ list: response.results }));
}

export default function* rootAvatarSaga() {
  yield all([takeEvery(fetchUserTiers, handleFetch)]);
}
